'use client'

import { FormDataProvider } from 'hook/useFormData'
import { Footer } from '@/components/footer'
import { Navbar } from '@/components/navbar'
import ExitIntentModal from '@/components/modals/exit-intent-modal'
import { useExitIntent } from '@/hook/useExitIntent'

export default function Layout({ children }: { children: React.ReactNode }) {
  const { showModal, closeModal } = useExitIntent({
    threshold: 50,
    maxDisplayCount: 3,
    delayBeforeShow: 5000,
  })

  return (
    <FormDataProvider>
      <div>
        <Navbar />
        <div>{children}</div>
        <Footer />
        <ExitIntentModal isOpen={showModal} onClose={closeModal} />
      </div>
    </FormDataProvider>
  )
}
